export default 'tenant-edit'
